<template>
  <div class="evaluate">
    <div class="banxin">
      <div class='head'>
        <router-link to="/myOrder">
          <div class='all'>我的订单</div>
        </router-link>
        <div class='arrow'></div>
        <div class='keyword'>评价</div>
      </div>
      <div class="content">
        <div class="top" v-for="(item, index) of product.skus" :key="index" v-show="item.commentId === 0">
          <div class="left">
            <div class="box">
              <img :src="item.image" alt="">
              <p class="name">{{item.productName}}</p>
              <div class="price">
                <span class="currency">¥</span>
                <span class="money">{{item.price}}</span>
              </div>
              <p class="size"><span v-for="(val, idx) in item.values" :key="idx">{{val}}</span></p>
            </div>
          </div>
          <div class="right">
            <div class="title">填写商品评价：</div>
            <el-form ref="form" label-width="80px">
              <el-form-item label="商品满意度评分" style="display:flex;align-items: center;">
                <el-rate style="margin-left:110px;" :colors=colors v-model="item.score" @change="changeScore"></el-rate>
              </el-form-item>
              <el-form-item label="商品印象">
                <div class="tag" :class="item.impression.indexOf(tagItem)!=-1?'active':''" v-for="(tagItem, tagIndex) in tag" :key="tagIndex" @click="tagClick(tagItem, index)">{{tagItem}}</div>
              </el-form-item>
              <el-form-item label="评价晒单">
                <el-input
                  type="textarea"
                  placeholder="请输入您的评语"
                  v-model="item.text"
                  rows=5
                  resize=none
                ></el-input>
                <br>
                <el-upload
                  :action="action"
                  list-type="picture-card"
                  :limit="5"
                  :on-success="(res,file)=>{return handSuccess(res, file, index)}"
                  :on-remove="(file, fileList)=>{return handleRemove(file, fileList, index)}">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <div class="imgNum">
                  共<span class="text">{{item.imgNum}}</span>张，还可以上传<span class="text">{{5-(item.imgNum)}}</span>张
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="bottom">
          <el-button plain @click="addComment" v-throttle>提交评价</el-button>
        </div>
      </div>
      <el-dialog
        :visible.sync="centerDialogVisible"
        width="30%"
        :show-close="false"
        center>
        <div>
          <img src="../../../static/image/wancheng@2x.png" alt="">
          <p>您的评价已成功提交</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="again" @click="buyAgain()" v-throttle v-if="product.collageId==0">再次购买</el-button>
          <el-button class="back" @click="$router.push('/')">返回首页</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import api from '../../api';
import api_b2c from "../../api_b2c";
import {listSearchMixin} from '../../config/mixin'
export default {
  mixins: [listSearchMixin],
  data () {
    return {
      status: 1,
      score: 5,
      text: '',
      impression: [],
      impressions: [],
      images: [],
      product: {},
      colors: [
        '#FF7800',
        '#FF7800',
        '#FF7800'
      ],
      tag: [
        '物美价廉',
        '物流很快',
        '值得买',
        '一般',
        '还可以',
        '差评'
      ],
      urls: [],
      dialogVisible: false,
      disabled: false,
      centerDialogVisible: false,
      evaluateData: {},
      commentId: '',
      evaluateList: {},
      action: api.upload,
      platform:'b2b'
    }
  },
  created () {
    this.platform = localStorage.getItem('platform');
    
    this.product = JSON.parse(this.$route.query.product)
    console.log(this.product)
    this.product.skus.map(item => {
      this.$set(item, 'imgNum', 0)
    })
    // let evaluate = []
    this.product.skus.map(j => {
      j['impression'] = []
      j['images'] = []
      j['score'] = 5
      j['urls'] = []
    })
    // console.log(this.product, 'product')
  },
  methods: {
    // 添加评论
    addComment () {
      let flag = true
      this.product.skus.map(j => {
        console.log(j.text)
        if (j.text === '' || j.text === undefined) {
          this.$message({
            showClose: true,
            message: '评价内容不能为空',
            type: 'warning'
          })
          flag = false
        }
      })
      if (flag) {
        let params = []
        this.product.skus.map(j => {
          params.push({
            orderId: this.product.orderId,
            skuId: j.skuId,
            productId: j.productId,
            image: j.urls.join(','),
            comment: j.text,
            star: j.score,
            impression: j.impression.join(',')
          })
        })
        let params1 = {
          url: api.addComment,
          method: 'POST',
          data: {
            params
          }
        }
        this.sendReq(params1, (res) => {
          // console.log(res)
          if (res.code === '200') {
            this.centerDialogVisible = true
          }
        })
      }
    },
    // 再次购买
    buyAgain () {
      let params = {
        url: this.platform == 'b2b' ? api.buyAgain : api_b2c.buyAgain,
        method: 'PUT',
        data: {
          orderId: this.orderId
        }
      }
      this.sendReq(params, (res) => {
        // console.log(res)
        if (res.code === '200') {
          //  this.$router.push('/shopping-trolley')
          if(this.platform == 'b2c'){
            self.$router.push("/shop_mall/shopping-trolley");
          }else{
            self.$router.push("/shopping-trolley");
          }
        }
      })
    },
    // 选择印象
    tagClick (tag, index) {
      // console.log(tag)
      if (this.product.skus[index].impression.indexOf(tag) === -1) {
        this.product.skus[index].impression.push(tag)
      } else {
        this.product.skus[index].impression.splice(this.product.skus[index].impression.indexOf(tag), 1)
      }
      this.$forceUpdate()
    },
    // 删除上传的图片
    handleRemove (file, fileList, index) {
      this.product.skus[index].urls = []
      for (var i in fileList) {
        this.product.skus[index].urls.push(fileList[i].response.data.url)
      }
      this.product.skus[index].imgNum = this.product.skus[index].urls.length
    },
    // 上传图片
    handSuccess (res, file, index) {
      this.product.skus[index].urls.push(res.data.url)
        this.product.skus[index].imgNum = this.product.skus[index].urls.length
    },
    changeScore () {
      this.$forceUpdate()
    }
  }
}
</script>
<style lang = "scss" scoped>
.evaluate{
  width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  padding-bottom: 143px;
  text-align: center;
  .banxin{
    width: 1252px;
    margin: 0 auto;
    height: 100%;
    .head {
      width: 100%;
      height: 64px;
      line-height: 64px;
      font-size: 16px;
      display: flex;
      align-items: center;
      .all {
        margin-right: 20px;
      }
      .keyword {
        margin: 0 20px;
        color: #ff7800;
      }
      .arrow {
        background-image: url('../../../static/image/xiangyou@2x.png');
        width: 5px;
        height: 10px;
      }
    }
    .content{
      width: 100%;
      background-color: #FFFFFF;
      .top{
        width: 100%;
        display: flex;
        border-bottom: 1px solid #E5E5E5;
        .left{
          border-right: 1px solid #EAEAEA;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          .box{
            width: 260px;
            img{
              width: 240px;
              max-height: 300px;
              margin-bottom: 23px;
            }
            .name{
              margin-bottom: 20px;
              font-size: 14px;
            }
            .price{
              margin-bottom: 23px;
              .currency{
                font-size: 12px;
              }
              .money{
                font-size: 18px;
              }
            }
            .size{
              font-size: 12px;
              color: #999999;
              span{
                margin-right: 10px;
              }
              span:last-child{
                margin-right: 0;
              }
            }
          }
        }
        .right{
          flex: 2;
          padding: 36px 36px 0;
          box-sizing: border-box;
          .title{
            width: 100%;
            padding-bottom: 12px;
            text-align: left;
            border-bottom: 1px dashed #EAEAEA;
          }
          >>>.el-form{
              text-align: left;
              padding-top: 20px;
            .el-form-item{
              display: flex;
              .el-form-item__label{
                flex: 1;
                text-align: left;
                color: #999999;
              }
              .el-form-item__content{
                margin-left: 10px !important;
                flex: 6;
                .el-rate{
                  margin-left: 10px;
                  transform: scale(1.4);
                }
                .tag{
                  display: inline-block;
                  width: 100px;
                  box-sizing: border-box;
                  text-align: center;
                  border: 1px solid #EAEAEA;
                  margin: 0 10px 10px 0;
                  cursor: pointer;
                }
                .active{
                  border-color: #FF7800;
                }
                .el-textarea{
                  margin-bottom: 20px;
                }
                p{
                  font-size: 14px;
                }
                img{
                  width: 80px;
                  height: 80px;
                  margin-right: 15px;
                }
                .el-upload--picture-card,.el-upload-list--picture-card{
                  width: 80px;
                  height: 80px;
                  line-height: 80px;
                  .el-upload-list__item-actions,.el-upload-list__item{
                    width: 80px;
                    height: 80px;
                  }
                  i{
                    line-height: 2.1;
                  }
                  .el-icon-delete,.el-icon-zoom-in{
                    font-size: 20px;
                  }
                  .el-icon-upload-success{
                    line-height: 1;
                  }
                }
                .imgNum{
                  display: inline-block;
                  height: 60px;
                  margin-top: 50px;
                  color: #999999;
                  .text{
                    color: #FF7800;
                  }
                }
              }
            }
          }
        }
      }
      .bottom{
        width: 100%;
        padding: 30px 0;
        margin-top: 2px;
        /* border-top: 1px solid #EAEAEA; */
        .el-button{
          width: 25%;
          font-size: 20px;
          background-color: #FF7800;
          padding: 20px 0;
          color: #FFFFFF;
        }
      }
    }
    >>>.el-dialog{
      .el-dialog__body{
        display: flex;
        justify-content: center;
        div{
          text-align: center;
          img{
            width: 80px;
            height: 80px;
            margin-bottom: 40px;
          }
          p{
            font-size: 22px;
          }
        }
      }
      .el-dialog__footer{
        .again{
          background-color: #FF7800;
          border: 1px solid #FF7800;
          color: #FFFFFF;
          border-radius: 0;
        }
        .back{
          color: #FF7800;
          border: 1px solid #FF7800;
          background-color: #FFFFFF;
          box-sizing: border-box;
          border-radius: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/evaluate/index.vue